// Formatage du temps mm:ss.cc (centiemes) — Lot A. Un SEUL endroit partage par le HUD
// (client/render.ts) et tous les classements (solo/online/leaderboard/campagne) pour garantir
// un affichage identique partout. Precision reelle = 1/30 s (le temps derive des ticks du moteur),
// mais on l'affiche au centieme (deterministe, jamais de faux chiffres). Pur, aucun DOM.
export function formatTime(ms: number): string {
  const t = Math.max(0, ms)
  const mm = Math.floor(t / 60000)
  const ss = Math.floor((t % 60000) / 1000)
  const cc = Math.floor((t % 1000) / 10)
  return `${String(mm).padStart(2, '0')}:${String(ss).padStart(2, '0')}.${String(cc).padStart(2, '0')}`
}
